import { render } from "./SessionQuestionsListView.vue?vue&type=template&id=247a0622&scoped=true&ts=true"
import script from "./SessionQuestionsListView.vue?vue&type=script&lang=ts"
export * from "./SessionQuestionsListView.vue?vue&type=script&lang=ts"

import "./SessionQuestionsListView.vue?vue&type=style&index=0&id=247a0622&scoped=true&lang=css"

import exportComponent from "D:\\Ventla Code\\New Admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-247a0622"]])

export default __exports__